import classNames from 'classnames';
import { FC, HTMLAttributes, PropsWithChildren, ReactNode } from 'react';

import { WarningSvg } from './Icons/WarningSvg';

type InputErrorProps = HTMLAttributes<HTMLParagraphElement> &
    PropsWithChildren<{
        message?: string | ReactNode;
    }>;

export const InputError: FC<InputErrorProps> = ({
    message,
    className,
    ...props
}) => {
    return message ? (
        <p
            {...props}
            className={classNames(
                'flex flex-row items-center text-sm text-orange-500 dark:text-orange-500',
                className,
            )}>
            <WarningSvg className="mr-1 w-[16px]" />
            {message}
        </p>
    ) : null;
};
